import React, { Component } from 'react';
import './Criteria.css';
import _ from 'lodash';
import CriteriaTabs from './CriteriaTabs/CriteriaTabs';
import CreateCrierialModal from './CreateCrierialModal/CreateCrierialModal';
import uuidv1 from 'uuid/v1';
import SelectedSegmentAttractivenessError from './SelectedSegmentAttractivenessError/SelectedSegmentAttractivenessError';

class Criteria extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createdData: false,
            editedData: false,
            createCriterialModal: false,
            tabs: [],
            attractivenessData: [],
            addedNewItemState: false,
            selectedSegmentAttractivenessError: false,
            goNextStape: false,
            weighting: [],
            weightingArrayIsEmpty: true,
            haveRemovedWeighting: false,
        }
    }

    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: "attractivness"
        }
        let data = {
            projectId: this.props.projectId,
            type: "segmentation"
        }
        this.props.getCustomerGroup(data)
        this.props.getAttractivness(body)
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEmpty(nextProps.getCustomerGroupsData) && this.state.tabs.length === 0 && !nextProps.getCustomerGroupsFetching) {
            let tabs = this.state.tabs;
            nextProps.getCustomerGroupsData.map(item => {
                if (item) {
                    tabs.push({
                        groupId: item.groupId,
                        groupName: item.groupName
                        //attractivnessId: uuidv1(),
                    });
                }
            })
            this.setState({ tabs })
        }
        if (nextProps.attractivnessData.Items && _.isEmpty(this.state.attractivenessData)) {
            if (!nextProps.attractivnessFetching && !_.isEmpty(nextProps.attractivnessData.Items) && !_.isEmpty(nextProps.getCustomerGroupsData)) {
                this.setState({
                    attractivenessData: nextProps.attractivnessData.Items[0].attractivness,
                    editedData: true, createdData: false,
                });
                this.addedNewItem(true);
                let tabTitleArr = [];
                // nextProps.attractivnessData.Items[0].attractivness.map(item=>{
                //     let data = nextProps.getCustomerGroupsData.find(r => r.groupId === item.groupId);
                //     tabTitleArr.push({
                //         groupId: data.groupId,
                //         groupName: data.groupName
                //         //attractivnessId: uuidv1(),
                //     });

                // });


                let newData = _.uniqBy(tabTitleArr, 'groupId')
                newData.map(item => {
                    this.state.tabs.push(item)
                })
            }

            if (!nextProps.attractivnessFetching && !_.isEmpty(nextProps.attractivnessData.Items) && nextProps.attractivnessData.Items[0].weighting && !_.isEmpty(nextProps.attractivnessData.Items[0].weighting) && this.state.weightingArrayIsEmpty) {

                nextProps.attractivnessData.Items[0].weighting.map(item => {
                    this.state.weighting.push(item)
                })

                this.setState({
                    weighting: this.state.weighting,
                    weightingArrayIsEmpty: false
                });
            }

            if (_.isEmpty(nextProps.attractivnessData.Items) && !this.state.createdData) {
                this.setState({ createdData: true, editedData: false })
            }
        }

        if (!nextProps.craetCriteriaFetching && nextProps.craetCriteriaData.statusCode === 200 && nextProps.stepState === 1 && this.state.goNextStape) {
            this.props.stateNext();
            this.setState({ goNextStape: false })
        }



    }

    createCriterial = () => {
        this.setState({
            createCriterialModal: true
        })
        // let body = {
        //     projectId: this.props.projectId,
        //     type: "influencerMap"
        // }
        // this.props.getCustomerGroup(body)
    }

    onValueCheckBoxSelect = (e, id) => {

        let item = this.state.attractivenessData.find(r => r.attractivnessId === id);
        item.important = e;

        let getNotImportantData = this.state.weighting.find(r => r.attractivnessId === id);
        if (getNotImportantData) {
            _.remove(this.state.weighting, (comment) => {
                return (comment.attractivnessId === id)
            }, this.setState({ weighting: this.state.weighting, haveRemovedWeighting: true }));
        }

    }

    addedNewItem = (value) => {
        this.setState({ addedNewItemState: value });
    }

    onNewValueAdd = (data, groupId) => {
        const uuidv1 = require('uuid/v1');
        this.state.attractivenessData.push({
            attractivnessId: data.criteriaId,
            groupId: groupId,
            important: data.important,
            name: data.name
        });

        this.addedNewItem(true);
        this.setState({
            attractivenessData: this.state.attractivenessData
        })
    }

    createCriterialTab = (requestData, step) => {
        this.state.tabs.push({
            groupId: requestData.groupId,
            groupName: requestData.groupName
            //attractivnessId: uuidv1(),
        });

        this.createCriterialModalClose();
    }

    createCriterialModalClose = () => {
        this.setState({
            createCriterialModal: false
        })
    }

    selectedSegmentAttractivenessErrorModal = () => {
        this.setState({ selectedSegmentAttractivenessError: !this.state.selectedSegmentAttractivenessError })
    }

    onNextButtonClick = () => {

        let tabTitleArr = [];
        let newAttractive = [];
        let newWeighting = []
        this.state.attractivenessData.map(item => {
            let data = this.props.getCustomerGroupsData.find(r => r && r.groupId === item.groupId);
            if (data) {
                newAttractive.push(item)
            }
        })
        this.state.attractivenessData = newAttractive
        this.state.attractivenessData.map(item => {
            this.state.weighting.map(weight => {
                if (item.attractivnessId === weight.attractivnessId) {
                    newWeighting.push(weight)
                }
            })
        })
        this.state.weighting = newWeighting;
        this.state.attractivenessData.map(item => {
            let data = this.props.getCustomerGroupsData.find(r => r && r.groupId === item.groupId);

            tabTitleArr.push({
                groupId: data.groupId,
                groupName: data.groupName
                //attractivnessId: uuidv1(),
            });
        });

        let newData = _.uniqBy(tabTitleArr, 'groupId')

        let validationArr = [];
        newData.map(item => {
            let val = this.state.attractivenessData.find(r => r.groupId === item.groupId && r.important) ? 'true' : 'false';

            validationArr.push(val)
        })

        let nextButtonValidation = validationArr.find(r => r === 'false') ? false : true;

        if (nextButtonValidation) {
            if (this.state.createdData) {
                let body = {
                    projectId: this.props.projectId,
                    type: "attractivness",
                    attractivness: this.state.attractivenessData
                }
                this.setState({ goNextStape: true })
                this.props.createCriteriaTab(body)
            }
            if (this.state.editedData) {
                let body;
                if (this.state.haveRemovedWeighting) {
                    body = {
                        id: this.props.attractivnessData.Items[0].id,
                        projectId: this.props.projectId,
                        type: "attractivness",
                        attractivness: this.state.attractivenessData,
                        weighting: this.state.weighting
                    }
                } else {
                    body = {
                        id: this.props.attractivnessData.Items[0].id,
                        projectId: this.props.projectId,
                        type: "attractivness",
                        attractivness: this.state.attractivenessData,
                        weighting: this.state.weighting
                    }
                }

                this.setState({ goNextStape: true })
                this.props.editCriteriaTab(body);

            }
        } else {
            this.selectedSegmentAttractivenessErrorModal();
        }
    }

    onValueDelete = (index) => {
        let updatedData = [];
        for (let item of this.state.attractivenessData) {
            item.attractivnessId !== index.attractivnessId && updatedData.push(item);
        }
        this.setState({
            attractivenessData: updatedData
        })
        // , () => this.deleteRequest())
    }

    deleteRequest = () => {

        let body = {
            type: 'attractivness',
            id: this.props.attractivnessData.Items[0].id,
            projectId: this.props.projectId,
            attractivness: this.state.attractivenessData
        }

        this.props.editCriteriaTab(body);
    }

    onDeleteTab = (id) => {
        let updatedData = [];
        let updatedTab = [];

        for (let item of this.state.attractivenessData) {
            item.groupId !== id && updatedData.push(item);
        }
        for (let item of this.state.tabs) {
            item.groupId !== id && updatedTab.push(item);
        }


        this.setState({
            attractivenessData: updatedData,
            tabs: updatedTab
        }, () => this.deleteRequest())
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {

        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-four arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-four arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-four arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-four arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                        <div className="col-sm-12">
                            <h5>ATTRACTIVENESS</h5>
                        </div>
                    </div>
                    {!this.props.craetCriteriaFetching &&
                        <div className='row'>
                            <div className="col-xl-8 col-lg-8 col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                        <div className="col-md-12">
                                            <div className="criteria-title-box">
                                                <h5>Criteria of Attractiveness</h5>
                                                <span>What makes a segment or customer group attractive to you?</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            {(!this.props.attractivnessFetching && this.props.attractivnessData.Items) &&
                                                <CriteriaTabs
                                                    createCriterial={this.createCriterial}
                                                    getAttractivness={this.props.getAttractivness}
                                                    //attractivnessFetching={this.props.attractivnessFetching}
                                                    //attractivnessData={this.props.attractivnessData}
                                                    tabs={this.state.tabs}
                                                    attractivenessData={this.state.attractivenessData}
                                                    onNewValueAdd={this.onNewValueAdd}
                                                    onValueCheckBoxSelect={this.onValueCheckBoxSelect}
                                                    addedNewItem={this.addedNewItem}
                                                    addedNewItemState={this.state.addedNewItemState}
                                                    onValueDelete={this.onValueDelete}
                                                    onDeleteTab={this.onDeleteTab}
                                                    tabStep={this.props.tabStep}
                                                    onTabChange={this.props.onTabChange}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        <a href="/toolkit" className='btn empty-btn default'>Back</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* {this.state.createCriterialModal &&
                        <CreateCrierialModal
                            getCustomerGroupsFetching={this.props.getCustomerGroupsFetching}
                            getCustomerGroupsData={this.props.getCustomerGroupsData}
                            attractivnessFetching={this.props.attractivnessFetching}
                            attractivnessData={this.props.attractivnessData}
                            createCriterialModalClose={this.createCriterialModalClose}
                            createCriterialTab={this.createCriterialTab}

                        />
                    } */}
                    {this.state.selectedSegmentAttractivenessError &&
                        <SelectedSegmentAttractivenessError
                            selectedSegmentAttractivenessErrorModal={this.selectedSegmentAttractivenessErrorModal}
                        />
                    }
                    {this.props.craetCriteriaFetching &&
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className="card-body">
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}
export default (Criteria);



// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/Criteria/Criteria.jsx